import { AfterContentChecked, AfterViewInit, SimpleChanges, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, OnChanges, OnDestroy, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import { element } from 'protractor';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/services/util.service';

declare var $: any;
@Component({
  selector: 'app-tablelayout',
  templateUrl: './tablelayout.component.html',
  styleUrls: ['./tablelayout.component.css']
})
export class TablelayoutComponent implements OnInit, OnChanges, OnDestroy { //to use this compnent, shadow the implementation on activity log component for reference
  @Input() data = []; // data to display on table.
  @Input() filterItems: Array<any>; //loads the filter criteria
  @Output() loadDataEvent = new EventEmitter<any>(); // fires the eventhandler that loads the data
  @Output() rowClicked = new EventEmitter<any>();
  @Input() count: number = 0; //the total number of data records
  @Input() columnsToRemove: Array<any>; //the property of the data type that you don't want a column created for.
  // Column order, headers and sort keys, as sent by the API. Columns used to be
  // inferred from the row keys, which is why the API smuggled the order and the
  // header text into the property name ("1.Name") — the keyvalue pipe sorts keys
  // alphabetically, so without a prefix the columns came out in the wrong order.
  // Left optional: a table with no metadata still falls back to the row keys.
  @Input() columns: TableColumn[];
  @Input() offset = 25; //number of records to load at a time
  @Input() allowMultiSelect = false;
  @Input() allowExport = false;
  @Input() selectBy = '';
  @Input() operation: Operation[];
  @Input() noRecordText = "No records";
  @Output() onItemSelected: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() onOperationActionFired: EventEmitter<Operation> = new EventEmitter<Operation>();
  @Input() exportFileName = 'export';

  filterTimeout: any; // store debounce timer
  reloadPending = false; // a sort/filter change that arrived while a load was in flight
  displayedData: Array<any> = [];
  sortBy = '';
  sortAscending = false;
  showFilterPanel = false;
  currentPage = 0;
  scrollingFunction;
  isLoading: boolean = false;
  enableOperation: boolean = false;
  public operationButtonTypeEnum = OperationButtonType;
  @ViewChildren('selectrow') selectRows!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('operationdropdown') operationdropdown!: ElementRef<any>;
  @ViewChild('tableElement') tableElement: ElementRef<any>;
  isAllRowsSelected: boolean;
  resultDone = false;
  tableOperationsForAdmin;

  constructor(public util: UtilService, public headerInfo: ComponentheaderService, private toastr: ToastrService) { 
  }

  get scrollingBody() {
    let scrollingbody = document.getElementById('home-main-wrap');
    if (window.innerWidth <= 767) {//767 because that's the value used in home.component.css
      scrollingbody = scrollingbody.parentElement;
    }
    return scrollingbody;
  }
  async ngOnInit() {
    await this.LoadData();    
    this.scrollingFunction = this.onScroll.bind(this);
    this.scrollingBody.addEventListener('scroll', this.scrollingFunction);
  }

  /**
   * Exports the rows currently loaded — what the table has pulled in so far, which is
   * page one plus whatever infinite scroll has added. It makes no requests of its own.
   *
   * This is deliberately the simple behaviour. The alternative, fetching the whole
   * filtered set, needs paging, a ceiling and progress reporting; the count on the
   * button is what keeps "loaded so far" from being a surprise.
   */
  async export() {
    if (!this.displayedData?.length) {
      this.toastr.info("There is nothing to export.");
      return;
    }
    try {
      await this.writeAndDownloadXLSX(this.displayedData);
    }
    catch (e) {
      this.toastr.error("Could not prepare the export. Please try again.");
      console.error('export failed:', e);
    }
  }

  async writeAndDownloadXLSX(rows: any[]){
    // Loaded on demand — xlsx is a multi-MB dependency only needed when someone
    // actually clicks export, not on every page that happens to render a table.
    const XLSX = await import('xlsx');

    // Built from the data and the column metadata, not by scraping the rendered table.
    // Scraping meant the file depended on how the DOM happened to be rendered; this way
    // the headers and their order match the columns the API declared.
    const columns = this.resolvedColumns;
    const sheetRows = rows.map(row => {
      const record = {};
      columns.forEach(column => record[column.label] = this.formatForExport(row[column.key]));
      return record;
    });

    const workSheet = XLSX.utils.json_to_sheet(sheetRows, { header: columns.map(c => c.label) });
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet);
    const excelBuffer = XLSX.write(workBook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.exportFileName}-${formatDate(new Date(), 'yyyy-MM-dd-HHmm', 'en-US')}.xlsx`;
    link.click();
    // revoked on a timeout, not immediately: some browsers abort a download whose
    // blob URL is released in the same tick as the click
    setTimeout(() => window.URL.revokeObjectURL(url), 10000);
  }

  /** Matches how the same value is rendered in the table. */
  private formatForExport(value: any): any {
    if (this.isValidDate(value)) {
      return formatDate(value, 'yyyy-MM-dd HH:mm:ss', 'en-US');
    }
    return value ?? '';
  }

  ngOnChanges(change: SimpleChanges) {    
    if ('data' in change) {      
      //adding new data
      if (this.data?.length > 0 && this.data){
        this.displayedData = [...this.displayedData, ... this.data]
      }
      else if (this.data?.length == 0){
          this.resultDone = true;        
          this.displayedData = [];
      }
      
      this.isLoading = false;

      // a sort or filter change that arrived mid-load runs now the load has landed
      if (this.reloadPending) {
        this.reloadPending = false;
        this.reload();
      }
    }
    if ('count' in change) {
      console.log(this.count);
    }
    this.setupAdminActions();
  }
  
  setupAdminActions(){        
    if(this.allowMultiSelect && this.operation?.length > 0 && this.displayedData?.length > 0){     
      this.operation.forEach(op =>{
        if(!this.headerInfo.headerDisplay.adminactions.some(o => o.displaytext == op.Title)){
          if(op.Type == this.operationButtonTypeEnum.Button){
            this.headerInfo.headerDisplay.adminactions.push({displaytext: op.Title, callback: () => this.performOperationAction(op), isTableAction: true, disabled: true, classes: op.fasClass});
          }
          else if( op.Type == this.operationButtonTypeEnum.Dropdown){
            let childrenActions = [];

            op.ChildOperation.forEach(child =>{
              if(child.Type == this.operationButtonTypeEnum.DropDownItem){
                childrenActions.push({displaytext: child.Title, callback: () => this.performOperationAction(child), isTableAction: true, classes: []});
              }
            });

            this.headerInfo.headerDisplay.adminactions.push({displaytext: op.Title, isTableAction: true, disabled: true, classes: op.fasClass, childrenActions: childrenActions});
          }
        }
        else{
          console.warn(`${op.Title} already exists in Admin actions. Possible duplicated prevented`)
        }
      });
    }
    
    // Export is no longer registered as a header action. It lives in the table's own
    // toolbar, next to the filters it acts on. The header registration also pushed the
    // action before its callback existed, so the first click after landing on the page
    // did nothing.
  }

  async onScroll() {    
    if (this.needsMoreDataOnScreen() && !this.resultDone && !this.isLoading && this.count != this.displayedData.length) {
      await this.LoadData();
    }
  }
  needsMoreDataOnScreen() {
    const s = $(this.scrollingBody).scrollTop(),
      d = this.scrollingBody.scrollHeight,
      c = $(this.scrollingBody).height();
    const scrollPercent = (s / (d - c)) * 100;
    return scrollPercent > 75;
  }

  ngOnDestroy(): void {
    this.scrollingBody.removeEventListener('scroll', this.scrollingFunction);
    // this was not cleared before, so a pending filter reload survived navigation away
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
  }

  async LoadData(clearDisplayedData = false) {    
    if (!this.isLoading) {      
      this.isLoading = true;
      this.currentPage++;
      if (this.currentPage == 0 || clearDisplayedData) {
        this.displayedData = [];
      }

      //fires the eventHandler that loads data
      this.loadDataEvent.emit(
        {
          page: this.currentPage,
          offset: this.offset,
          filters: this.filterItems,
          sortBy: this.sortBy,
          sortAscending: this.sortAscending
        }
      );
    }
  }

  setValueForDropdownFilter(data: any, label: string) {
    let filter = this.filterItems.find(f => f.label == label);
    filter.value = data;
    this.currentPage = 0;
    this.onFilterInputChange();
  }

  isValidDate(value: any): boolean {
    if (typeof value === 'string') {
      const dateValue = new Date(value);
      return !isNaN(dateValue.getTime());
    }
    return false;
  }
  shouldDisplayColumn(value: string): boolean {
    return !this.columnsToRemove?.includes(value);
  }

  /**
   * The columns to render. Prefers the metadata the API sent; falls back to the row
   * keys for a table whose endpoint does not send any, so both kinds of consumer work.
   */
  get resolvedColumns(): TableColumn[] {
    if (this.columns?.length > 0) {
      return this.columns.filter(c => this.shouldDisplayColumn(c.key));
    }
    if (!this.displayedData?.length) {
      return [];
    }
    return Object.keys(this.displayedData[0])
      .filter(key => this.shouldDisplayColumn(key))
      .map(key => ({ key, label: key, sortKey: null }));
  }

  /** The one filter promoted out of the panel and into the toolbar. */
  get searchFilter() {
    return this.filterItems?.find(f => f.search);
  }
  /** Everything else, which lives behind the Filters toggle. */
  get panelFilters() {
    return this.filterItems?.filter(f => !f.search) ?? [];
  }
  /** Drives the chips — one per filter the user has actually set. */
  get activeFilters() {
    return this.filterItems?.filter(f => f.value !== null && f.value !== undefined && f.value !== '') ?? [];
  }
  get hasActiveFilters(): boolean {
    return this.activeFilters.length > 0;
  }

  chipValue(filterOption: any): string {
    if (filterOption.date && filterOption.value) {
      return new Date(filterOption.value).toLocaleString();
    }
    if (filterOption.checkbox) {
      return filterOption.value ? 'Yes' : 'No';
    }
    return filterOption.value;
  }

  async removeFilter(filterOption: any) {
    filterOption.value = null;
    await this.reload();
  }

  toggleFilterPanel() {
    this.showFilterPanel = !this.showFilterPanel;
  }

  /** 0-100 for a progress column, clamped so bad data cannot draw outside the track. */
  percentFor(item: any, column: TableColumn): number {
    const raw = Number(item?.[column.percentKey]);
    if (isNaN(raw)) {
      return 0;
    }
    return Math.max(0, Math.min(100, raw));
  }

  isSortable(column: TableColumn): boolean {
    return !!column.sortKey;
  }

  /**
   * First click sorts ascending, second flips it. Sorting is applied by the API, not
   * in the browser — the table is paged, so ordering the loaded rows alone would put
   * a page boundary in the middle of the sort.
   */
  async toggleSort(column: TableColumn) {
    if (!this.isSortable(column)) {
      return;
    }
    if (this.sortBy === column.sortKey) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortBy = column.sortKey;
      this.sortAscending = true;
    }
    await this.reload();
  }

  sortIcon(column: TableColumn): string {
    if (this.sortBy !== column.sortKey) {
      return 'fa-sort';
    }
    return this.sortAscending ? 'fa-sort-up' : 'fa-sort-down';
  }

  ariaSort(column: TableColumn): string {
    if (!this.isSortable(column) || this.sortBy !== column.sortKey) {
      return 'none';
    }
    return this.sortAscending ? 'ascending' : 'descending';
  }

  async onFilterInputChange(option = null, value = '') {
    if(option){
      option.value = value;
    }

    if(this.filterTimeout){
      clearTimeout(this.filterTimeout);
    }

    this.filterTimeout = setTimeout
    (async () => 
      {
        await this.reload();
      } 
    , 2000);
  }
  /**
   * Re-runs the query from page one, for a sort or filter change.
   *
   * If a load is already in flight the reload is *queued*, not dropped. LoadData refuses
   * to run while isLoading is true, which used to swallow the click outright: sortBy had
   * already been changed by toggleSort, so the first click on a header appeared to do
   * nothing and the second one sorted descending, skipping ascending entirely. It showed
   * up on the course student list because that page issues two or three requests per
   * load, leaving a long window in which clicks were discarded.
   *
   * Queuing rather than forcing keeps the requests serialised — two overlapping loads
   * would append their rows to a list the second one had already cleared.
   */
  async reload(){
    if (this.isLoading) {
      this.reloadPending = true;
      return;
    }
    this.currentPage = 0;
    this.resultDone = false;
    await this.LoadData(true);
  }
  filterHasValue() {
    return !this.filterItems.some(f => f.value)
  }
  clearFilter() {
    // this used to reload the entire page, discarding scroll position and
    // forcing a full re-download of the application
    this.filterItems?.forEach(f => f.value = null);
    this.reload();
  }
  onCheckBoxClicked(e) {
    this.multiSelect(e);
   
    let selected: string[] = this.selectRows.filter(item => item.nativeElement.checked)
      .map(item => this.displayedData[item.nativeElement.id][this.selectBy]);// selectBy would be the column which we want to retrieve its values

    this.enableOperation = this.selectRows.some(i => i.nativeElement.checked);  
    if(this.tableOperationsForAdmin == null)
      this.tableOperationsForAdmin = this.headerInfo.headerDisplay.adminactions.filter(action => action.isTableAction);
    this.tableOperationsForAdmin.map(action => action.disabled = !this.enableOperation);
    this.onItemSelected.emit(selected.filter(i => i != undefined));
  }

  private multiSelect(e){
    if (e.target.id === 'headselect') {
      if (e.target.checked) 
        this.setCheckBoxes(true);      
      else 
        this.setCheckBoxes(false);      
    }else if(this.isAllRowsSelected && !e.target.checked){ 
      this.setCheckBoxes(false);
      document.getElementById('headselect')['checked'] = false;      
    }
  }
  private setCheckBoxes(value: boolean){
    this.selectRows.forEach(input => {
      input.nativeElement.checked = value;
    });
    this.isAllRowsSelected = value;
  }

  actionsDropdownClicked() {
    setTimeout(
      (() => {
        if (
          this.operationdropdown.nativeElement.getAttribute('aria-expanded') == 'true'
        ) {
          $(this.operationdropdown.nativeElement.querySelector('i')).addClass(
            'fa-caret-up'
          );
          $(this.operationdropdown.nativeElement.querySelector('i')).removeClass(
            'fa-caret-down'
          );
        } else {
          $(this.operationdropdown.nativeElement.querySelector('i')).addClass(
            'fa-caret-down'
          );
          $(this.operationdropdown.nativeElement.querySelector('i')).removeClass(
            'fa-caret-up'
          );
        }
      }).bind(this),
      1
    );
  }

  performOperationAction(operation: Operation){        
    if(this.enableOperation){      
      this.onOperationActionFired.emit(operation);
      operation.invokeCallback();
    }     
  }

  rowClick(item: any){
    this.rowClicked.emit(item);
  }
}

/** Mirrors ImpataLibrary.Models.TableColumnMetadata. */
export interface TableColumn {
  key: string;
  label: string;
  /** null when the API cannot sort by this column. */
  sortKey: string | null;
  /** null renders as text; 'progress' draws a bar beneath the cell's text. */
  type?: string | null;
  /** for 'progress': the property holding the 0-100 figure. */
  percentKey?: string | null;
}

export class Operation{
    public Id: any;
    public Title: string;
    public Type: OperationButtonType;
    public ChildOperation: Operation[];
    public fasClass: string[];
    // public CallBack(callback: () => void): void {
    //   console.log('Operations Callback fired');      
    //   callback();
    // }
    public CallBack: (() => void) | null;
    
    constructor(title: string, type: OperationButtonType, fasClass:string[], children: Operation[] = null, callback: (() => void) | null = null, id = null) {
      this.Id = id;
      this.Title = title;
      this.Type = type;
      this.ChildOperation = children;
      this.fasClass = fasClass;
      this.CallBack = callback ? callback.bind(this) : null;
    }

    public invokeCallback(): void {
      if (this.CallBack) {
        console.log('Operations Callback fired');
        this.CallBack();
      }
    }
}

export enum OperationButtonType{
  Button,
  Dropdown,
  DropDownItem
}
